import React from 'react';
import Error from '.';

export default function EmptyEinError(): React.JSX.Element {
  return (
    <Error
      title='Your Employer Identification Number (EIN) is Required'
      message='To proceed with Vault, we require your Employer Identification
            Number (EIN) to be on file. Please contact our support team and they
            will be happy to collect your EIN details. We apologize for any
            inconvenience this may cause.'
    />
  );
}
